import {Deserializable} from '../../../../pipes/Deserializable';

export class MBranch implements Deserializable {
  indexNo: number;
  branchCode: string;
  name: string;
  type: string;
  findGroup: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  telephoneNumber: string;
  color: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/view/service/m-branch/model/m-branch.ts